import './PopupMSG.css'
import React from 'react'

function PopupMSG({icon, message, title}) {
    return (
        <div className='popup'>
            <div className='inner-popup'>
                <div className='celebrationImg'>
                    <img src={icon} alt='celebration' />
                </div>
                <h1>{title}</h1>
                <p>{message}</p>
            </div>
        </div>
    )
}

export default PopupMSG;
